import React, { useState, useCallback } from 'react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { CenteredSpinner } from '@confluence/confluence-shared-components';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ReadOnlyOverlay = styled.div({
	background: token('color.background.input'),
	height: '100%',
	position: 'fixed',
	left: 0,
	top: 0,
	width: '100%',
	zIndex: 601 /* to be above overlays (e.g., / menu) */,
});

export const Spinner = ({ shouldShowSpinner }) =>
	shouldShowSpinner ? (
		<ReadOnlyOverlay>
			<CenteredSpinner size="medium" />
		</ReadOnlyOverlay>
	) : null;

export const useSpinner = () => {
	const [shouldShowSpinner, setShouldShowSpinner] = useState<boolean>(false);

	const showSpinner = useCallback(() => setShouldShowSpinner(true), []);
	const hideSpinner = useCallback(() => setShouldShowSpinner(false), []);

	return {
		showSpinner,
		hideSpinner,
		shouldShowSpinner,
	};
};
